import { tv } from 'tailwind-variants';

export const emptySidebarStyles = tv({
  slots: {
    container:
      'flex h-full flex-col items-center justify-center p-4 text-center text-sm font-light text-neutral-500',
    icon: 'mb-2 text-3xl',
    title: 'text-lg font-semibold',
    suggestion: 'leading-snug',
  },
});
